export { RibbonComponent } from './ribbon.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/ribbon/index.ts